import { Chiclet as Chic } from './Chiclet'
import styled, { useTheme } from 'styled-components'
import { Icon } from './images'
import { useState } from 'react'

export const ChicletMenuItem = styled(Chic)`
  ${({ theme: { button, colors } }) => `
  margin: 0.5rem;
  padding: 0.5rem;
  text-wrap: nowrap;
  width: auto;
  box-shadow: 0px 0px 6px 1px ${colors('chrome', 0.5)};
  &.active{
    box-shadow: 0px 0px 6px 1px ${colors('background', 0.5)};
    background-color: ${colors('chrome', 0.25)};
  }
`}
`

const PopoverOverlay = styled.div`
  ${({ theme: { colors } }) => `
    position: absolute;
    bottom: 0;
    left: 0;
    top: 0;
    right: 0;
    z-index: 9999;
  `}
`

const Popover = styled.div`
  ${({ theme: { button, colors } }) => `
    margin-left: -0.5rem;
    padding: 0rem;
    position: absolute;
    bottom: 3rem;
    left: 0;
  `}
`

const Container = styled.div`
  ${({ $show, theme: { colors } }) => `
    max-height: 2.5rem;
    overflow: ${$show ? 'visible' : 'hidden'};
    position: relative;
    ${Popover}, & + ${PopoverOverlay}{
      visibility: ${$show ? 'visible' : 'hidden'};
    }
  `}
`

const MenuTrigger = styled(Chic)``

export const ChicletMenu = ({ children, className, icon = 'menu' }) => {
  const [show, setMenu] = useState()
  const { colors } = useTheme()
  return (
    <>
      <Container className={className} $show={show}>
        <MenuTrigger onClick={() => setMenu((value) => !value)}>
          <Icon icon={icon} fill={colors('foreground')} />
        </MenuTrigger>
        <Popover>{children}</Popover>
      </Container>
      <PopoverOverlay onClick={() => setMenu((value) => !value)} />
    </>
  )
}
